import { Button, Input, Select, Switch } from "antd";
import React, { useState } from "react";

function CustomDiscount({
  isCustomDiscount,
  setDiscountValue,
  customDiscountType,
  setIsCustomDiscount,
  setSelectedDiscount,
  customDiscountAmount,
  setCustomDiscountType,
  setCustomDiscountAmount,
}) {
  const [inputStatus, setInputStatus] = useState("");
  const selectBefore = (
    <Select
      className=""
      value={customDiscountType}
      onChange={(type) => {
        setCustomDiscountType(type);
      }}
    >
      <Option value="value">Amount</Option>
      <Option value="percentage">Percentage</Option>
    </Select>
  );
  const selectAfter = (
    <Select value={customDiscountType}>
      <Option value="value">₹</Option>
      <Option value="percentage">%</Option>
    </Select>
  );
  const handleCustomDiscountChange = (event) => {
    const {
      target: { value },
    } = event;
    const isValid = /^-?\d+(\.\d*)?$/.test(value);
    setInputStatus(!isValid ? "error" : "");
    if (isValid) {
      setCustomDiscountAmount(value);
      if (value > 100) {
        setCustomDiscountType("value");
      }
    }
  };
  return (
    <div>
      <div className="border rounded p-2 m-1 mt-2">
        <div className="d-flex justify-content-between w-100 align-items-center">
          <h3>Custom Discount</h3>
          <Switch
            onChange={(toggle) => {
              setIsCustomDiscount(toggle);
              if (toggle === false) {
                setSelectedDiscount(null);
              }
            }}
          />
        </div>
        {isCustomDiscount && (
          <div className="d-flex gap-3 me-0">
            <Input
              status={inputStatus}
              onChange={handleCustomDiscountChange}
              addonBefore={customDiscountAmount > 100 ? "Amount" : selectBefore}
              addonAfter={customDiscountAmount > 100 ? "₹" : selectAfter}
              defaultValue={customDiscountAmount}
            />
            <Button
              onClick={() => {
                setSelectedDiscount({
                  code: "custom_discount",
                  amount: customDiscountAmount,
                  type: customDiscountType,
                  label: `Custom ${customDiscountAmount} ${
                    customDiscountType === "percentage" ? "%" : "₹"
                  }`,
                });
                setDiscountValue(customDiscountAmount);
              }}
            >
              Submit
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}

export default CustomDiscount;
